export const getTableQueryKey = (options: {
  tableKey: string

  filterParams: any
  page?: number

  products?: any

  extra?: Record<string, unknown>
}) => [
  options.tableKey,
  JSON.stringify(options.filterParams),
  String(options.page ?? 1),
  String(options.products ?? -1), // -1 is no product filter
  JSON.stringify(options.extra ?? {}), // extra is used for additional params
]
